module.exports = __webpack_public_path__ + "img/img_flag_yt.b737a744.png";